<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-share-external`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M18 18v4h-6v20h24V22h-6v-4h8a2 2 0 012 2v24a2 2 0 01-2 2H10a2 2 0 01-2-2V20a2 2 0 012-2h8zm7.264-15.586l7.778 7.778a1 1 0 010 1.415l-1.415 1.414a1 1 0 01-1.414 0l-4.235-4.235-.08 18.206a1 1 0 01-.996.996l-1.893.008a1 1 0 01-.997-.88l-.008-.125.083-18.572-4.602 4.602a1 1 0 01-1.414 0l-1.414-1.414a1 1 0 010-1.415l7.778-7.778a2 2 0 012.829 0z"/></svg>
</template>
<script>

export default {
  name: 'IconShareExternal',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
